import { ON_RUNNER } from '../../consts.js';

export default function OnRunner(props) {
  if (ON_RUNNER) {
    return props.children;
  } else {
    return null;
  }
}
